// extracted by mini-css-extract-plugin
export default {"scrollbar":"HVScrollBarLine_module-MRWA34DV_scrollbar__s9gHV","thumb":"HVScrollBarLine_module-MRWA34DV_thumb__gS2dk","corner":"HVScrollBarLine_module-MRWA34DV_corner__Ds4GO"};